// export const BASE_API = "http://localhost/landing/public/api"
// export const BASE_API_GAMBAR = "http://localhost/landing/public"
export const BASE_API = "https://landing-be.smpithatoy.com/api"
export const BASE_API_GAMBAR = "https://landing-be.smpithatoy.com"
export const NAMA_SEKOLAH = "SMP IT Hatoy"